import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Leaderboard',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h(
        "g",
        {
          attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" }
        },
        [h("line", {
          attrs: { x1: "1.5", y1: "2.5", x2: "1.5", y2: "21.5" }
        }), h("line", {
          attrs: { "stroke-width": "2", x1: "5", y1: "4", x2: "22", y2: "4" }
        }), h("line", {
          attrs: { "stroke-width": "2", x1: "5", y1: "8", x2: "19", y2: "8" }
        }), h("line", {
          attrs: { "stroke-width": "2", x1: "5", y1: "12", x2: "16", y2: "12" }
        }), h("line", {
          attrs: { "stroke-width": "2", x1: "5", y1: "20", x2: "10", y2: "20" }
        }), h("line", {
          attrs: { "stroke-width": "2", x1: "5", y1: "16", x2: "13", y2: "16" }
        })]
      )]
    );
  }
};